const Divider = () => {
  return <hr className="border-none h-[1px] my-8 mx-0 bg-[#E7E9EC]" />
}

export default Divider
